import React from 'react';
import {classes} from './ItemSubscription.st.css';
import {Text} from 'wix-ui-tpa/cssVars';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {SubscriptionFrequency} from '../../../../../domain/models/checkout/LineItems/SubscriptionSettings.model';
import {getFrequencyText, getSubscriptionDuration} from '../LineItem.utils';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {SubscriptionInfoModel} from '../../../../../domain/models/checkout/LineItems/SubscriptionInfo.model';

export interface SubscriptionProps {
  dataHook: string;
  subscription: SubscriptionInfoModel;
}

export enum SubscriptionDataHook {
  Name = 'SubscriptionDataHook.Name',
  Duration = 'SubscriptionDataHook.Duration',
  StartDate = 'SubscriptionDataHook.StartDate',
  FreeTrial = 'SubscriptionDataHook.FreeTrial',
}

export const ItemSubscription = ({subscription, dataHook}: SubscriptionProps) => {
  const {language} = useEnvironment();
  const localeKeys = useLocaleKeys();
  const startDate = subscription.subscriptionSettings.startDate
    ? new Date(Number(subscription.subscriptionSettings.startDate)).toLocaleDateString(language, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      })
    : undefined;
  const shouldDisplayFreeTrial =
    subscription.subscriptionSettings.freeTrialPeriod &&
    subscription.subscriptionSettings.freeTrialPeriod.interval &&
    subscription.subscriptionSettings.freeTrialPeriod.frequency !== SubscriptionFrequency.UNDEFINED;

  const duration = getSubscriptionDuration(subscription.subscriptionSettings, localeKeys);
  const freeTrialFrequency = shouldDisplayFreeTrial
    ? getFrequencyText({
        frequency: subscription.subscriptionSettings.freeTrialPeriod.frequency,
        cycles: subscription.subscriptionSettings.freeTrialPeriod.interval!,
        localeKeys,
      })
    : '';

  return (
    <div className={classes.root} data-hook={dataHook}>
      {subscription.title && (
        <Text data-hook={SubscriptionDataHook.Name} className={classes.text}>
          {subscription.title}
        </Text>
      )}
      <Text data-hook={SubscriptionDataHook.Duration} className={classes.text}>
        {duration}
      </Text>
      {startDate && (
        <Text data-hook={SubscriptionDataHook.StartDate} className={classes.text}>
          {localeKeys.checkout.pricingPlans.startDate.label({date: startDate})}
        </Text>
      )}
      {shouldDisplayFreeTrial && (
        <Text data-hook={SubscriptionDataHook.FreeTrial} className={classes.text}>
          {localeKeys.checkout.pricingPlans.freeTrial.label({
            number: subscription.subscriptionSettings.freeTrialPeriod.interval,
            frequency: freeTrialFrequency,
          })}
        </Text>
      )}
    </div>
  );
};
